import { TravelData } from "../shared/type";
import { Dispatch, SetStateAction } from "react";
import { Message } from "../shared/type";

interface UseStreamTravelDataProps {
  setMessages: Dispatch<SetStateAction<Message[]>>;
  scrollToBottom: () => void;
}

export const useStreamTravelData = ({
  setMessages,
  scrollToBottom,
}: UseStreamTravelDataProps) => {
  const streamTravelData = async (messageId: string, fullData: TravelData) => {
    const delay = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));

    // 逐步添加行程数据
    if (fullData.itinerary && fullData.itinerary.length > 0) {
      for (let i = 0; i < fullData.itinerary.length; i++) {
        await delay(400); // 每个行程项延迟400ms
        setMessages((prev) =>
          prev.map((msg) =>
            msg.id === messageId
              ? {
                  ...msg,
                  data: {
                    ...msg.data!,
                    itinerary: fullData.itinerary!.slice(0, i + 1),
                  },
                }
              : msg
          )
        );
        // 滚动到底部
        setTimeout(() => scrollToBottom(), 50);
      }
    }

    // 逐步添加热门景点
    if (fullData.topAttractions && fullData.topAttractions.length > 0) {
      await delay(300);
      for (let i = 0; i < fullData.topAttractions.length; i++) {
        await delay(200);
        setMessages((prev) =>
          prev.map((msg) =>
            msg.id === messageId
              ? {
                  ...msg,
                  data: {
                    ...msg.data!,
                    topAttractions: fullData.topAttractions!.slice(0, i + 1),
                  },
                }
              : msg
          )
        );
        setTimeout(() => scrollToBottom(), 50);
      }
    }

    // 逐步添加旅行建议
    if (fullData.travelTips && fullData.travelTips.length > 0) {
      await delay(300);
      for (let i = 0; i < fullData.travelTips.length; i++) {
        await delay(150);
        setMessages((prev) =>
          prev.map((msg) =>
            msg.id === messageId
              ? {
                  ...msg,
                  data: {
                    ...msg.data!,
                    travelTips: fullData.travelTips!.slice(0, i + 1),
                  },
                }
              : msg
          )
        );
        setTimeout(() => scrollToBottom(), 50);
      }
    }
  };

  return { streamTravelData };
};
